import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 12l5 5l10 -10","key":"svg-0"}],["path",{"d":"M2 12l5 5m5 -5l5 -5","key":"svg-1"}]]

const IconChecks = createReactComponent('outline', 'checks', 'Checks', __iconNode);

export default IconChecks;